/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonStrategyInfo
 */
export interface JsonStrategyInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonStrategyInfo
     */
    allowedActions?: Array<JsonStrategyInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategyInfo
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategyInfo
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategyInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategyInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategyInfo
     */
    serieId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategyInfo
     */
    serieTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategyInfo
     */
    status?: JsonStrategyInfoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategyInfo
     */
    strategyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategyInfo
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStrategyInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategyInfo
     */
    updatedBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStrategyInfo
     */
    userCount?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonStrategyInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonStrategyInfoStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonStrategyInfoFromJSON(json: any): JsonStrategyInfo {
    return JsonStrategyInfoFromJSONTyped(json, false);
}

export function JsonStrategyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonStrategyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'serieId': !exists(json, 'serieId') ? undefined : json['serieId'],
        'serieTitle': !exists(json, 'serieTitle') ? undefined : json['serieTitle'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'strategyId': !exists(json, 'strategyId') ? undefined : json['strategyId'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userCount': !exists(json, 'userCount') ? undefined : json['userCount'],
    };
}

export function JsonStrategyInfoToJSON(value?: JsonStrategyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'companyId': value.companyId,
        'companyName': value.companyName,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'serieId': value.serieId,
        'serieTitle': value.serieTitle,
        'status': value.status,
        'strategyId': value.strategyId,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userCount': value.userCount,
    };
}

